import { createSlice } from "@reduxjs/toolkit";
import { updateOnlineDecisionReducer } from "../../reducer/updateOnlineDecision/updateOnlineDecisionReducer";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const updateOnlineDecisionSlice = createSlice({
  name: "updateOnlineDecision",
  initialState,
  reducers: {
    resetUpdateOnlineDecision: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateOnlineDecisionReducer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateOnlineDecisionReducer.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateOnlineDecisionReducer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateOnlineDecision } = updateOnlineDecisionSlice.actions;

export default updateOnlineDecisionSlice.reducer;
